
import React, { useState } from 'react'
import { Flex,Spinner } from '@chakra-ui/react'
export const FormHeader = ({ isUpdateMode, heading, onSubmit, onUpdate,isSubmitting = false,isDisabled = false   }) => {
    return (
        <>
            <div className='py-2 px-3 flex items-center justify-between mb-2' style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                <div className="font-semibold text-xl">{isUpdateMode ? `Update ${heading}` : `Create ${heading}`}</div>
                {/* < size={36} className='hover:bg-sky-100 rounded p-1 transition duration-300 ease-in-out' onClick={OpenConfirmation}/> */}
                <Flex gap="2">
                    <button mr={3} className='border rounded-md py-2 px-3 font-semibold hover:bg-gray-200' onClick={() => window.history.back()} disabled={isSubmitting} >
                        Cancel
                    </button>
                      <button
                        className="main-btn px-4"                      
                        onClick={onSubmit}
                        disabled={isSubmitting || isDisabled} 
                    >
                        {isSubmitting ? (
                               <>
                                <Spinner size="sm" />
                             <span>{isUpdateMode ? "Updating..." : "Submitting..."}</span>
                                </>
                        ) : (
                            <span>{isUpdateMode ? "Update" : "Submit"}</span>
                        )}
                    </button>
                </Flex>
            </div>
        </>
    )
}


// import React from 'react'
// import { Flex, Spinner } from '@chakra-ui/react'

// export const FormHeader = ({ isUpdateMode, heading, onSubmit, isSubmitting = false }) => {
//     return (
//         <>
//             <div className='py-2 px-3 flex items-center justify-between mb-2' style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
//                 <div className="font-semibold text-xl">{isUpdateMode ? `Update ${heading}` : `Create ${heading}`}</div>
//                 <Flex gap="2" alignItems="center">
//                     <button
//                         mr={3}
//                         className='border rounded-md py-2 px-3 font-semibold hover:bg-gray-200'
//                         onClick={() => window.history.back()}
//                         disabled={isSubmitting} // Disable cancel button too during submission
//                     >
//                         Cancel
//                     </button>
//                    <button className="main-btn"
//                         onClick={(e) => {
//                             !isUpdateMode ? onSubmit(e) : onUpdate(e);
//                         }}>
//                         <span>{isUpdateMode ? "Update" : "Submit"}</span>
//                     </button>
//                     <button
//                         className="main-btn"
//                         style={{padding: '8px 16px'}}
//                         onClick={onSubmit}
//                         disabled={isSubmitting} // Disable button when submitting
//                     >
//                         {isSubmitting ? (
//                             <Flex alignItems="center" gap="2">
//                                 <Spinner size="sm" />
//                                 <span>{isUpdateMode ? "Updating..." : "Submitting..."}</span>
//                             </Flex>
//                         ) : (
//                             <span>{isUpdateMode ? "Update" : "Submit"}</span>
//                         )}
//                     </button>
//                 </Flex>
//             </div>
//         </>
//     )
// }